import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    countryList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    employeeList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    leaveTypeList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    departmentList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    leaveStateList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    hrCategoryList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    itCategoryList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    psCategoryList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    ticketStatusList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    psTypeList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    coreValuesList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    clientList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    employmentStatusList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    forexList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    clientTeamList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    assetTypeList: {
      items: [],
      requesting: false,
    },
    assetStatusList: {
      items: [],
      requesting: false,
    },
  };

export const optionlistSlice = createSlice({
  name: 'optionlist',
  initialState,
  reducers: {
    getCountryList: (state, action) => {		
      state.countryList.requesting = true;
      state.countryList.error = null;
      state.countryList.items = [];
      state.countryList.success = false;
      state.countryList.filters = action.payload;
    },
    getCountryListSuccess: (state, action) => {
      state.countryList.requesting = false;        
      state.countryList.items = [
        { 
          value: "all", 
          label: "All locations",
          code: "All"
        },
        ...action.payload,
      ];
      state.countryList.success = true; 
    },
    getCountryListFail: (state, action) => {        
      state.countryList.requesting = false;
      state.countryList.error = action.payload;
    },

    getEmployeeList: (state, action) => {		
      state.employeeList.requesting = true;
      state.employeeList.error = null;
      state.employeeList.items = [];
      state.employeeList.success = false;
      state.employeeList.filters = action.payload;
    },
    getEmployeeListSuccess: (state, action) => {
      state.employeeList.requesting = false;        
      state.employeeList.items = action.payload;
      state.employeeList.success = true; 
    },
    getEmployeeListFail: (state, action) => {        
      state.employeeList.requesting = false;
      state.employeeList.error = action.payload;
    },

    getLeaveTypeList: (state, action) => {		
      state.leaveTypeList.requesting = true;
      state.leaveTypeList.error = null;
      state.leaveTypeList.items = [];
      state.leaveTypeList.success = false;
      state.leaveTypeList.filters = action.payload;
    },
    getLeaveTypeListSuccess: (state, action) => {
      state.leaveTypeList.requesting = false;        
      state.leaveTypeList.items = [
        { value: "all", label: "All Leave Types" },
        ...action.payload,
      ];
      state.leaveTypeList.success = true; 
    },
    getLeaveTypeListFail: (state, action) => {        
      state.leaveTypeList.requesting = false;
      state.leaveTypeList.error = action.payload;
    },

    getDepartmentList: (state, action) => {		
      state.departmentList.requesting = true;
      state.departmentList.error = null;
      state.departmentList.items = [];
      state.departmentList.success = false;
      state.departmentList.filters = action.payload;
    },
    getDepartmentListSuccess: (state, action) => {
      state.departmentList.requesting = false;        
      state.departmentList.items = [
        { value: "all", label: "All Department"},
        ...action.payload,
      ];
      state.departmentList.success = true; 
    },
    getDepartmentListFail: (state, action) => {        
      state.departmentList.requesting = false;
      state.departmentList.error = action.payload;
    },

    getLeaveStateList: (state, action) => {		
      state.leaveStateList.requesting = true;
      state.leaveStateList.error = null;
      state.leaveStateList.items = [];
      state.leaveStateList.success = false;
      state.leaveStateList.filters = action.payload;
    },
    getLeaveStateListSuccess: (state) => {
      state.leaveStateList.requesting = false;        
      state.leaveStateList.items = [
        { value: "all", label: "All Status" },
        { value: "On Leave", label: "Currently On Leave" },
        { value: "Upcoming", label: "Upcoming Leave" },
      ];
      state.leaveStateList.success = true; 
    },

    getHrCategoryList: (state, action) => {		
      state.hrCategoryList.requesting = true;
      state.hrCategoryList.error = null;
      state.hrCategoryList.items = [];
      state.hrCategoryList.success = false;
      state.hrCategoryList.filters = action.payload;
    },
    getHrCategoryListSuccess: (state, action) => {
      state.hrCategoryList.requesting = false;        
      state.hrCategoryList.items = [
        { value: "all", label: "All Categories"},
        ...action.payload,
      ];
      state.hrCategoryList.success = true; 
    },
    getHrCategoryListFail: (state, action) => {        
      state.hrCategoryList.requesting = false;
      state.hrCategoryList.error = action.payload;
    },

    getItCategoryList: (state, action) => {		
      state.itCategoryList.requesting = true;
      state.itCategoryList.error = null;
      state.itCategoryList.items = [];
      state.itCategoryList.success = false;
      state.itCategoryList.filters = action.payload;
    },
    getItCategoryListSuccess: (state, action) => {
      state.itCategoryList.requesting = false;        
      state.itCategoryList.items = [
        { value: "all", label: "All Categories"},
        ...action.payload,
      ];
      state.itCategoryList.success = true; 
    },
    getItCategoryListFail: (state, action) => {        
      state.itCategoryList.requesting = false;
      state.itCategoryList.error = action.payload;
    },

    getPsCategoryList: (state, action) => {		
      state.psCategoryList.requesting = true;
      state.psCategoryList.error = null;
      state.psCategoryList.items = [];
      state.psCategoryList.success = false;
      state.psCategoryList.filters = action.payload;
    },
    getPsCategoryListSuccess: (state, action) => {
      state.psCategoryList.requesting = false;        
      state.psCategoryList.items = [
        { value: "all", label: "All Categories"},
        ...action.payload,
      ];
      state.psCategoryList.success = true; 
    },
    getPsCategoryListFail: (state, action) => {        
      state.psCategoryList.requesting = false;
      state.psCategoryList.error = action.payload;
    },

    getTicketStatusList: (state, action) => {		
      state.ticketStatusList.requesting = true;
      state.ticketStatusList.error = null;
      state.ticketStatusList.items = [];
      state.ticketStatusList.success = false;
      state.ticketStatusList.filters = action.payload;
    },
    getTicketStatusListSuccess: (state, action) => {
      state.ticketStatusList.requesting = false;        
      state.ticketStatusList.items = [
        { value: "all", label: "All Status"},
        ...action.payload,
      ];
      state.ticketStatusList.success = true; 
    },
    getTicketStatusListFail: (state, action) => {        
      state.ticketStatusList.requesting = false;
      state.ticketStatusList.error = action.payload;
    },
    getPsTypeList: (state, action) => {		
      state.psTypeList.requesting = true;
      state.psTypeList.error = null;
      state.psTypeList.items = [];
      state.psTypeList.success = false;
      state.psTypeList.filters = action.payload;
    },
    getPsTypeListSuccess: (state, action) => {
      state.psTypeList.requesting = false;        
      state.psTypeList.items = [
        { value: "all", label: "All Messages"},
        ...action.payload,
      ];
      state.psTypeList.success = true; 
    },
    getPsTypeListFail: (state, action) => {        
      state.psTypeList.requesting = false;
      state.psTypeList.error = action.payload;
    },
    getCoreValuesList: (state, action) => {		
      state.coreValuesList.requesting = true;
      state.coreValuesList.error = null;
      state.coreValuesList.items = [];
      state.coreValuesList.success = false;
      state.coreValuesList.filters = action.payload;
    },
    getCoreValuesListSuccess: (state, action) => {
      state.coreValuesList.requesting = false;        
      state.coreValuesList.items = action.payload;
      state.coreValuesList.success = true; 
    },
    getCoreValuesListFail: (state, action) => {        
      state.coreValuesList.requesting = false;
      state.coreValuesList.error = action.payload;
    },
    getClientList: (state, action) => {		
      state.clientList.requesting = true;
      state.clientList.error = null;
      state.clientList.items = [];
      state.clientList.success = false;
      state.clientList.filters = action.payload;
    },
    getClientListSuccess: (state, action) => {
      state.clientList.requesting = false;        
      state.clientList.items = action.payload;
      state.clientList.success = true; 
    },
    getClientListFail: (state, action) => {        
      state.clientList.requesting = false;
      state.clientList.error = action.payload;
    },
    getEmploymentStatusList: (state, action) => {		
      state.employmentStatusList.requesting = true;
      state.employmentStatusList.error = null;
      state.employmentStatusList.items = [];
      state.employmentStatusList.success = false;
      state.employmentStatusList.filters = action.payload;
    },
    getEmploymentStatusListSuccess: (state, action) => {
      state.employmentStatusList.requesting = false;        
      state.employmentStatusList.items = action.payload;
      state.employmentStatusList.success = true; 
    },
    getEmploymentStatusListFail: (state, action) => {        
      state.employmentStatusList.requesting = false;
      state.employmentStatusList.error = action.payload;
    },
    getForexList: (state, action) => {		
      state.forexList.requesting = true;
      state.forexList.error = null;
      state.forexList.items = [];
      state.forexList.success = false;
      state.forexList.filters = action.payload;
    },
    getForexListSuccess: (state, action) => {
      state.forexList.requesting = false;        
      state.forexList.items = action.payload;
      state.forexList.success = true; 
    },
    getForexListFail: (state, action) => {        
      state.forexList.requesting = false;
      state.forexList.error = action.payload;
    },
    getClientTeamList: (state, action) => {		
      state.clientTeamList.requesting = true;
      state.clientTeamList.error = null;
      state.clientTeamList.items = [];
      state.clientTeamList.success = false;
      state.clientTeamList.filters = action.payload;
    },
    getClientTeamListSuccess: (state, action) => {
      state.clientTeamList.requesting = false;        
      state.clientTeamList.items = action.payload;
      state.clientTeamList.success = true; 
    },
    getClientTeamListFail: (state, action) => {        
      state.clientTeamList.requesting = false;
      state.clientTeamList.error = action.payload;
    },
    getAssetTypeList: (state) => {
      state.assetTypeList.requesting = true;
      state.assetTypeList.error = null;
    },
    getAssetTypeListSuccess: (state, action) => {
      state.assetTypeList.requesting = false;
      state.assetTypeList.items = action.payload;
    },
    getAssetTypeListFail: (state, action) => {
      state.assetTypeList.requesting = false;
      state.assetTypeList.error = action.payload;
    },
    getAssetStatusList: (state) => {
      state.assetStatusList.requesting = true;
      state.assetStatusList.error = null;
    },
    getAssetStatusListSuccess: (state, action) => {
      state.assetStatusList.requesting = false;
      state.assetStatusList.items = action.payload;
    },
    getAssetStatusListFail: (state, action) => {
      state.assetStatusList.requesting = false;
      state.assetStatusList.error = action.payload;
    },
  },
})

export const { 
  getCountryList, getCountryListSuccess, getCountryListFail,
  getEmployeeList, getEmployeeListSuccess, getEmployeeListFail,
  getLeaveTypeList, getLeaveTypeListSuccess, getLeaveTypeListFail,
  getDepartmentList, getDepartmentListSuccess, getDepartmentListFail,
  getLeaveStateList, getLeaveStateListSuccess,
  getHrCategoryList, getHrCategoryListSuccess, getHrCategoryListFail,
  getItCategoryList, getItCategoryListSuccess, getItCategoryListFail,
  getPsCategoryList, getPsCategoryListSuccess, getPsCategoryListFail,
  getTicketStatusList, getTicketStatusListSuccess, getTicketStatusListFail,
  getPsTypeList, getPsTypeListSuccess, getPsTypeListFail,
  getCoreValuesList, getCoreValuesListSuccess, getCoreValuesListFail,
  getClientList, getClientListSuccess, getClientListFail,
  getEmploymentStatusList, getEmploymentStatusListSuccess, getEmploymentStatusListFail,
  getForexList, getForexListSuccess, getForexListFail,
  getClientTeamList, getClientTeamListSuccess, getClientTeamListFail,
  getAssetTypeList, getAssetTypeListSuccess, getAssetTypeListFail,
  getAssetStatusList, getAssetStatusListSuccess, getAssetStatusListFail,
} = optionlistSlice.actions

export default optionlistSlice.reducer


